/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { memo, useContext, useState } from 'react';
import NavbarLogo from 'assets/img/navbar_logo.png';
import RizeLogo from 'assets/img/rize2.svg';
import RizeText from 'assets/img/rize1.svg';
import { Hooks } from 'providers';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ListData from 'components/layouts/sidebar/ListSidebar';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import DataHooks from './dataHooks';

function Sidebar(props) {
  const location = useLocation();
  const path = location.pathname;
  const { sideBar } = useContext(Hooks);
  const [showBusinessProcess, setShowBusinessProcess] = useState(false);
  const [showOriganizations, setShowOrganizations] = useState(false);
  const [showDatabank, setShowDatabank] = useState(false);
  const [showMatrix, setShowMatrix] = useState(false);
  const [showWla, setShowWla] = useState(false);
  const { dashboard } = useSelector((state) => ({
    dashboard: state.auth.role.dashboard,
  }));
  const forListData = {
    showOriganizations,
    showMatrix,
    showBusinessProcess,
    showDatabank,
    showWla,
    setShowBusinessProcess,
    setShowMatrix,
    setShowOrganizations,
    setShowDatabank,
    setShowWla,
  };
  const { sideBarHide } = DataHooks();

  const showSideBar = () => {
    if (path === '/job-level/add' || path === '/job-level/edit') {
      return 'd-none';
    }
    return '';
  };

  return (
    <nav
      className={`sidebar sidebar-collapsed sidebar-sticky ${sideBarHide(path)} ${showSideBar()} ${
        !sideBar && 'toggled'
      }`}
      style={{ zIndex: 999 }}
    >
      <div className={`${sideBar ? '' : ''} sidebar-content js-simplebar vh-100`}>
        <a className="sidebar-brand overflow-hidden" href="index.html">
          <img
            src={RizeLogo}
            alt="Rize.inc Logo"
            className="iconRize"
          />
          <img
            src={RizeText}
            alt="Rize.inc Text"
            className="iconRize-text"
          />
        </a>
        <ListData {...forListData} backOffice={props.bo} {...props} />
      </div>
    </nav>
  );
}

export default memo(Sidebar);
